import { Login, ProfileType } from '@witkac/kartamiejska-shared';
import {
  authResource,
  AuthResource
} from '@witkac/kartamiejska-resources/dist/resources/auth.resource';

import { AbstractModule } from './abstract.module';
import { SessionStorage } from '@/enums/sessionStorage.enum';
import { apolloClient } from '@/apollo';

/**
 * Moduł autentykacji
 *
 * @class AuthModule
 * @extends {AbstractModule<AuthResource>}
 */
class AuthModule extends AbstractModule<AuthResource> {
  /**
   * Dane zalogowanego użytkownika
   *
   * @memberof AuthModule
   */
  public state = {
    data: undefined
  };

  public mutations = {
    /**
     * Zapisuje dane profilu do store
     *
     * @param localState state
     * @param profile profil użytkownika
     */
    save(localState: any, data: any): void {
      localState.data = data;
    }
  };
  public actions = {
    /**
     * Logowanie
     *
     * @param context context
     * @param data dane logowania
     */
    login: async (context: any, data: Login): Promise<boolean> => {
      const response = await this.resource.login(data.login, data.password);
      if (response.profile.type !== ProfileType.CLIENT) {
        throw new Error('Niepoprawny profil użytkownika.');
      }
      sessionStorage.setItem(SessionStorage.TOKEN, response.token);
      if (response.profile.id) {
        sessionStorage.setItem(
          SessionStorage.PROFILE_ID,
          response.profile.id.toString()
        );
      }
      if (response.profile.userId) {
        sessionStorage.setItem(SessionStorage.USER_ID, response.profile.userId);
      }
      context.commit('save', response);
      return response.hasAllConsents;
    },

    /**
     * Wylogowanie
     *
     * @param context context
     */
    logout: async (context: any): Promise<void> => {
      sessionStorage.clear();
      context.commit('save', undefined);
    }
  };
}
export default new AuthModule(authResource);
